import { render, staticRenderFns } from "./SabitAlacakliList.vue?vue&type=template&id=e28b05d8&scoped=true"
import script from "./SabitAlacakliList.vue?vue&type=script&lang=ts"
export * from "./SabitAlacakliList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28b05d8",
  null
  
)

export default component.exports